'use client';

import { createContext } from 'react';

import type { AccordionItemContextInterface } from '../types/accordion-item.types';

export const AccordionItemContext = createContext<AccordionItemContextInterface>({
  value: '',
});

AccordionItemContext.displayName = 'Accordion.Item.Context';
